import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setMsgAsync, Message } from './notificationsSlice';
import { generateQueryParams } from '../../utils';

export const getApplicationsAsync = createAsyncThunk(
  'admin/getApplications',
  async () => {
    try {
      const response = await axios.get('/api/v1/admin/applications');
      return response.data;
    } catch (e) {
      // dispatch(setMsgAsync(new Message(e.response.data).getAction()))
      return null;
    }
  },
);

export const getRolesAsync = createAsyncThunk('admin/getRoles', async () => {
  try {
    const response = await axios.get('/api/v1/admin/roles');
    return response.data;
  } catch (e) {
    // dispatch(setMsgAsync(new Message(e.response.data).getAction()))
    return null;
  }
});

export const getRecordingAsync = createAsyncThunk(
  'admin/getRecording',
  async ({ recordingName, page = 1 }) => {
    try {
      const response = await axios.get(
        '/api/v1/recordings/' + recordingName + '?page=' + page,
      );
      return response.data;
    } catch (e) {
      // dispatch(setMsgAsync(new Message(e.response.data).getAction()))
      return null;
    }
  },
);

export const getUsersAsync = createAsyncThunk('admin/getUsers', async () => {
  try {
    const response = await axios.get('/api/v1/admin/users');
    return response.data;
  } catch (e) {
    // dispatch(setMsgAsync(new Message(e.response.data).getAction()))
    return null;
  }
});

export const getCredentialsAsync = createAsyncThunk(
  'admin/getCredentials',
  async () => {
    try {
      const response = await axios.get('/api/v1/admin/credentials');
      return response.data;
    } catch (e) {
      // dispatch(setMsgAsync(new Message(e.response.data).getAction()))
      return null;
    }
  },
);

export const getSessionsAsync = createAsyncThunk(
  'admin/getSessions',
  async ({ params }) => {
    try {
      const response = await axios.get(
        `/api/v1/admin/sessions${generateQueryParams(params)}`,
      );
      return response.data;
    } catch (e) {
      return null;
    }
  },
);

export const stopSessionAsync = createAsyncThunk(
  'admin/stopSession',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/admin/sessions/stop', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const startSessionAsync = createAsyncThunk(
  'admin/startSession',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/admin/sessions/start', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const createUserAsync = createAsyncThunk(
  'admin/createUser',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/admin/users', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const restoreUserAsync = createAsyncThunk(
  'admin/restoreUser',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/admin/users/restore', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const createCredentialsAsync = createAsyncThunk(
  'admin/createCredentials',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post('/api/v1/admin/credentials', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const restoreCredentialsAsync = createAsyncThunk(
  'admin/restoreCredentials',
  async (value, { dispatch }) => {
    try {
      const response = await axios.post(
        '/api/v1/admin/credentials/restore',
        value,
      );
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const updateCredentialsAsync = createAsyncThunk(
  'admin/updateCredentials',
  async (value, { dispatch }) => {
    try {
      const response = await axios.put('/api/v1/admin/credentials', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const updateUsersAsync = createAsyncThunk(
  'admin/updateUsers',
  async (value, { dispatch }) => {
    try {
      const response = await axios.put('/api/v1/admin/users', value);
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const deleteCredentialsAsync = createAsyncThunk(
  'admin/deleteCredentials',
  async (value, { dispatch }) => {
    try {
      const response = await axios.delete(
        '/api/v1/admin/credentials/' + value.credentialId,
      );
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

export const deleteUsersAsync = createAsyncThunk(
  'admin/deleteUsers',
  async (value, { dispatch }) => {
    try {
      const response = await axios.delete(
        '/api/v1/admin/users/' + value.userId,
      );
      return response.data;
    } catch (e) {
      console.log(e);
      dispatch(setMsgAsync(new Message(e.response.data).getAction()));
      return null;
    }
  },
);

const initialState = {
  loading: {
    applications: false,
    sessions: null,
    credentials: false,
    users: false,
  },
  applications: [],
  sessions: [],
  users: [],
  credentials: [],
  roles: [],
  currentRecordingUrl: null,
  currentRecordingsParts: null,
};

export const applicationsSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setCurrentRecordingUrl: (state, action) => {
      state.currentRecordingUrl = action.payload;
    },
    setSessionloading: (state, action) => {
      state.loading.sessions = action.payload;
    },
    setCredentailsLoading: (state, action) => {
      state.loading.credentials = action.payload;
    },
    setUsersLoading: (state, action) => {
      state.loading.users = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApplicationsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.applications = action.payload;
      })
      .addCase(getCredentialsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.credentials = action.payload;
      })
      .addCase(getRolesAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.roles = action.payload;
      })
      .addCase(getRecordingAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.currentRecordingUrl = action.payload.url;
        state.currentRecordingsParts = action.payload.totalTime.total.minutes;
      })
      .addCase(getUsersAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.users = action.payload;
      })
      .addCase(restoreUserAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.users = null;
          return;
        }
        state.users = action.payload;
        state.loading.users = null;
      })
      .addCase(createUserAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.users = null;
          return;
        }
        state.users = action.payload;
        state.loading.users = null;
      })
      .addCase(createUserAsync.pending, (state) => {
        state.loading.users = true;
      })
      .addCase(createCredentialsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.credentials = null;
          return;
        }
        state.credentials = action.payload;
        state.loading.credentials = null;
      })
      .addCase(restoreCredentialsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.credentials = null;
          return;
        }
        state.credentials = action.payload;
        state.loading.credentials = null;
      })
      .addCase(createCredentialsAsync.pending, (state) => {
        state.loading.credentials = true;
      })
      .addCase(updateCredentialsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.credentials = action.payload;
        state.loading.credentials = null;
      })
      .addCase(updateUsersAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.users = action.payload;
        state.loading.credentials = null;
      })
      .addCase(deleteCredentialsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.credentials = null;
          return;
        }
        state.credentials = action.payload;
        state.loading.credentials = null;
      })
      .addCase(deleteCredentialsAsync.pending, (state) => {
        state.loading.credentials = true;
      })
      .addCase(deleteUsersAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.users = null;
          return;
        }
        state.users = action.payload;
        state.loading.users = null;
      })
      .addCase(deleteUsersAsync.pending, (state) => {
        state.loading.users = true;
      })
      .addCase(getSessionsAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.sessions = action.payload;
      })
      .addCase(stopSessionAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          return;
        }
        state.sessions = action.payload;
        state.loading.sessions = null;
      })
      .addCase(startSessionAsync.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.loading.sessions = null;
          return;
        }
        state.sessions = action.payload;
        state.loading.sessions = null;
      });
    // .addCase(stopSessionAsync.pending, (state, action) => {
    //     state.loading.sessions = action.payload.session_id
    // })
  },
});

export const getApplications = (state) => state.admin.applications;
export const getUsers = (state) => state.admin.users;
export const getRoles = (state) => state.admin.roles;
export const getSessions = (state) => state.admin.sessions;
export const getLoading = (state) => state.admin.loading;
export const getCredentials = (state) => state.admin.credentials;
export const getCurrentRecordingUrl = (state) =>
  state.admin.currentRecordingUrl;
export const getCurrentRecordingsParts = (state) =>
  state.admin.currentRecordingsParts;

export const {
  setSessionloading,
  setCredentailsLoading,
  setUsersLoading,
  setCurrentRecordingUrl,
} = applicationsSlice.actions;

export default applicationsSlice.reducer;
